module.exports = __webpack_public_path__ + "static/media/speech_24.751f7f85.svg";